interface CurrencyRelation {
  long_name: string
  id: number
  symbol: string
  short_name: string
  hash_currency: string
}

interface CurrencyObject {
  is_reverse: boolean
  value: number
  currency_id: number
  currency_to_id: number
  work_unit_id: number
  currency_relation: CurrencyRelation
  currency_to_relation: CurrencyRelation
}

const filterWithoutInverse = (records: CurrencyObject[]): CurrencyObject[] => {
  return records.filter((record) => !record.is_reverse)
}

export const reverseExchangeRate = (records: CurrencyObject[]): CurrencyObject[] => {
  const filteredRecords = filterWithoutInverse(records)
  const reversedRecords = filteredRecords.map((record) => ({
    ...record,
    currency_id: record.currency_to_id,
    currency_to_id: record.currency_id,
    currency_relation: record.currency_to_relation,
    currency_to_relation: record.currency_relation,
    value: parseFloat((1 / record.value).toFixed(15)),
    is_reverse: true,
  }))

  return [...records.filter((record) => !record.is_reverse), ...reversedRecords]
}
